import { detectFrustrationLevel } from '@/lib/assistantFreeText';

export function createEmptySessionMemory() {
  return {
    partySize: null,
    servicePreference: null,
    priceSensitivity: null,
    lastProducts: [],
    lastIntent: null,
    mood: null,
    scheduledTime: null,
    shownContextualProductIds: [],
    pendingCheckoutPrefill: null,
    orderCloseActive: false,
    awaitingOrderField: null,
    upsellShownThisClose: false,
    mapDeliveryQuote: null,
    assistantEntryMode: null,
    guidedOrderActive: false,
    guidedOrderDraft: null,
  };
}

export function updateSessionMemoryFromMessage(sessionMemoryRef, raw, n) {
  const mem = sessionMemoryRef.current;
  const mNum = n.match(/\b(?:para|somos)\s+(\d{1,2})\b/);
  if (mNum) {
    const v = parseInt(mNum[1], 10);
    if (v >= 1 && v <= 50) mem.partySize = v;
  }
  const wordNums = {
    dos: 2,
    tres: 3,
    cuatro: 4,
    cinco: 5,
    seis: 6,
    siete: 7,
    ocho: 8,
    nueve: 9,
    diez: 10,
  };
  const mW = n.match(/\bsomos\s+(dos|tres|cuatro|cinco|seis|siete|ocho|nueve|diez)\b/);
  if (mW && wordNums[mW[1]]) mem.partySize = wordNums[mW[1]];

  if (/\b(delivery|domicilio|a\s+domicilio|reparto|envio|envío)\b/.test(n)) mem.servicePreference = 'delivery';
  if (/\b(retiro|paso\s+a\s+buscar|para\s+llevar|para\s+retiro|take\s*away|pick\s*up)\b/.test(n)) {
    mem.servicePreference = 'pickup';
  }
  if (/\b(en el local|comer aca|comer acá|mesa|salon|salón|comer ahi|comer ahí)\b/.test(n)) {
    mem.servicePreference = 'local';
  }

  if (/\b(barato|barata|economico|económico|mas barato|más barato)\b/.test(n)) mem.priceSensitivity = 'cheap';
  if (/\b(normal|precio\s+normal|precio\s+estandar|precio estándar)\b/.test(n)) mem.priceSensitivity = 'normal';

  const fr = detectFrustrationLevel(n);
  if (fr >= 1) mem.mood = 'frustrated';
  else if (
    /\b(genial|excelente|buenisimo|buenísimo|que rico|qué rico|me\s+encanta|la raja|maravilloso|brutal)\b/.test(
      n
    ) ||
    /\b(muchas gracias|mil gracias)\b/.test(n)
  ) {
    mem.mood = 'happy';
  }

  const t1 = n.match(/\ba\s+las\s+(\d{1,2})(?::(\d{2}))?\b/);
  const t2 = n.match(/\btipo\s+(\d{1,2})\b/);
  if (t1) {
    const hh = t1[1];
    const mm = (t1[2] || '00').padStart(2, '0');
    mem.scheduledTime = `${hh}:${mm}`;
  } else if (t2) {
    mem.scheduledTime = `${t2[1]}:00`;
  }

  if (/\brecomiend|suger(i|í)/.test(n)) mem.lastIntent = 'recommend';
  if (
    /\b(carrito|checkout|cerrar\s+pedido|finalizar\s+pedido|pagar|quiero\s+pedir|hacer\s+el\s+pedido|listo\s+para\s+pedir)\b/.test(
      n
    )
  ) {
    mem.lastIntent = 'order';
  }
}
